// extracted by mini-css-extract-plugin
export var cardBody = "u3FzDpiE7OWs0VtvO05d";
export var hasHeader = "kNkibHBOJXm3PQQnTt6_";
export var icon = "tnJvklGeNcXTokvth3Oo";
export var iconTransfer = "kkBdtAAKPU70B4Igin6p";
export var iconTube = "faDrhDDeXhoeJgHaZFfg";
export var transferLeg = "S9QjO4ajwoUPEBAGB3Ug";